import { RoundedButton } from '../../styles/CustomButtons';
import { useAuth0 } from '@auth0/auth0-react';
import type { ButtonProps } from '@mui/material';
import { useAppDispatch } from '@store/hooks';
import { purgeWorkflowFor } from '@features/encounters/store/workflowPurgeMiddleware';
import { getOwner, clearOwner } from '@store/owner';

export const LogoutButton: React.FC<ButtonProps> = ({ variant = 'outlined', ...props }) => {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    // Clear workflow encounter ID (targeted purge - keeps other persisted state)
    const owner = getOwner();
    if (owner) {
      dispatch(purgeWorkflowFor(owner));
    }

    // Clear owner reference
    clearOwner();

    // Clear session data
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');

    // Note: lastUserLogin is preserved for "Welcome back" on next login
    // It's set during successful authentication in AuthenticationCallback.tsx

    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <RoundedButton onClick={handleLogout} variant={variant} {...props}>
      Logout
    </RoundedButton>
  );
};
